module.exports = __webpack_public_path__ + "static/media/hall-PC.57399efb.svg";